import {gsap} from "gsap";
import {rePostionContents} from "./cavasResize";
import { PixiPlugin } from "gsap/PixiPlugin";


gsap.registerPlugin(PixiPlugin);
const loader = PIXI.Loader.shared;
const sprites = {};
const info = {
    w: $(window).width(),
    h: $(window).height(),
    path: promokit.store('staticPath')
}


loader.add('ch1', info.path + '/promo/bns/history/2021/210512_dualwield/img/header-ch1.png');

let headerMotion = gsap.timeline({paused: true, delay: 0 });
let sec1Motion = gsap.timeline({paused: true, delay: 0 });
let sec2Motion = gsap.timeline({paused: true, delay: 0 });
let sec3Motion = gsap.timeline({paused: true, delay: 0 });
let sec4Motion = gsap.timeline({paused: true, delay: 0 });
let flag1 = false, flag2 = false, flag3 = false, flag4 = false, flag5 = false;
loader.load((loader, resources) => {
    sprites.ch1 = new PIXI.Sprite.fromImage(resources.ch1.texture);

    let mainCanvas = {};


    mainCanvas.app = new PIXI.Application({ width: info.w, height: info.h, transparent: true, resizeTo: window });
    $('.p-header__canvas').prepend(mainCanvas.app.view);

    mainCanvas.con = new PIXI.Container();
    mainCanvas.con.x = info.w/2 - 1920/2;
    mainCanvas.con.y = 0;
    mainCanvas.app.stage.addChild(mainCanvas.con);

    mainCanvas.ch1 = sprites.ch1;
    mainCanvas.ch1.x = info.w/2-350;
    mainCanvas.ch1.y = info.h-1100;
    mainCanvas.con.addChild(mainCanvas.ch1);

    $(window).on('resize', function(){
        info.w = $(window).width();
        info.h = $(window).height();
        rePostionContents(mainCanvas.con, info.w, info.h, 1920, 1080, false);
        mainCanvas.app.renderer.resize(info.w, info.h);
    });

    headerMotion
        .addLabel('step1', '+=0.7')
        .fromTo(mainCanvas.ch1, { pixi: { alpha: 0, saturation: 0, blur: 12 }, x: (info.w/2-350)-150 },
            { pixi: { alpha: 1, saturation: 0, blur: 12 }, x: (info.w/2-350), ease: 'power2.out', duration: 1 }, 'step1')
        .fromTo('.p-header__title', { scale: 3, opacity: 0 },
            { scale: 1, opacity: 1, duration: 1, ease: 'expo.inOut'}, 'step1+=0.5')
        .to([mainCanvas.ch1],{ pixi: { saturation: 1, blur: 0 }, duration: 2, ease: 'power2.out'}, 'step1+=1')

        .addLabel('step2', '-=1.3')
        .from('.quick', { x: 300, opacity: 0, duration: 1, ease: 'power2.out'}, 'step2')
        .from('.p-util', { y: 200, opacity: 0, duration: 1, ease: 'power2.out'}, 'step2')
        .from('.p-header__scroll', { y: 200, opacity: 0, duration: 1, ease: 'power2.out'}, 'step2')
        .from('.p-header__play', { opacity: 0, scale: 1.2, duration: 1, ease: 'power2.out'}, 'step2')

    sec1Motion
        .addLabel('step1', '+=0.2')
        .from('.p-sec1__title', { y: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1')
        .from('.p-sec1__txt1', { y: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.2')
        .from('.p-sec1__txt2', { y: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.4')
        .from('.p-sec1__txt3', { y: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.6')

    sec2Motion
        .addLabel('step1', '+=0.2')
        .from('.p-sec2__title', { x: -70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1')
        .from('.p-sec2__txt1', { x: -70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.2')
        .from('.p-sec2__txt2', { x: -70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.4')
        .from('.p-sec2__txt3', { x: -70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.6')

    sec3Motion
        .addLabel('step1', '+=0.2')
        .from('.p-sec3__title', { x: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1')
        .from('.p-sec3__txt1', { x: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.2')
        .from('.p-sec3__txt2', { x: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.4')
        .from('.p-sec3__txt3', { x: 70, opacity: 0, duration: 1, ease: 'power2.none'}, 'step1+=0.6')

})

function quick(){
    let $menu = $('.quick__item'),
        $btnTop = $('.quick__top'),
        $doc = $('html, body'),
        $contents = $('.p-header, .p-sec1, .p-sec2, .p-sec3, .p-sec4');
    let sclTop = $(window).scrollTop(),
        fixTop = $('.p-header').offset().top;

        if (!(fixTop <= sclTop)) $menu.removeClass('active');
    $menu.on('click', 'a', function(e){
        e.preventDefault();
        let target = $(this).attr("href"),
            offsetTop = $(target).offset().top;
        $doc.stop().animate({ scrollTop :offsetTop }, 800);
    });


    sclTop = $(window).scrollTop();
    $.each($contents, function(idx, item){
        let $target = $contents.eq(idx),
            i = idx,
            targetTop = $target.offset().top - $(window).height()/2;

        if (targetTop <= sclTop) {
            $menu.removeClass('active');
            $menu.eq(i).addClass('active');
            if( i == 0 && flag1 == false ){
                headerMotion.play();
                flag1 = true;
            }
            if( i == 1 && flag2 == false ){
                sec1Motion.play();
                flag2 = true;
            }
            if( i == 2 && flag3 == false ){
                sec2Motion.play();
                flag3 = true;
            }
            if( i == 3 && flag4 == false ){
                sec3Motion.play();
                flag4 = true;
            }
            if( i == 4 && flag5 == false ){
                sec4Motion.play();
                flag5 = true;
            }
        }
        if (!(fixTop <= sclTop)) $menu.removeClass('active');
    });
    sclTop >= fixTop ? $('.quick').addClass('quick--fix') : $('.quick').removeClass('quick--fix');
    $(window).scroll(function(){
        sclTop = $(window).scrollTop();
        $.each($contents, function(idx, item){
            let $target = $contents.eq(idx),
                i = idx,
                targetTop = $target.offset().top - $(window).height()/2;

            if (targetTop <= sclTop) {
                $menu.removeClass('active');
                $menu.eq(i).addClass('active');
                if( i == 0 && flag1 == false ){
                    headerMotion.play();
                    flag1 = true;
                }
                if( i == 1 && flag2 == false ){
                    sec1Motion.play();
                    flag2 = true;
                }
                if( i == 2 && flag3 == false ){
                    sec2Motion.play();
                    flag3 = true;
                }
                if( i == 3 && flag4 == false ){
                    sec3Motion.play();
                    flag4 = true;
                }
                if( i == 4 && flag5 == false ){
                    sec4Motion.play();
                    flag5 = true;
                }
            }
            if (!(fixTop <= sclTop)) $menu.removeClass('active');
        });
        sclTop >= fixTop ? $('.quick').addClass('quick--fix') : $('.quick').removeClass('quick--fix');
    });
}

export default quick;


// WEBPACK FOOTER //
// ./src/js/quick.js